<!--
    Summary:
        首张banner图
    ChangeLog:
       zty on 2021/2/21 added
-->
<template>
  <div class="v-banner">
    <div class="banner-wrapper">
      <slot></slot>
    </div>
    <!-- <div class="bottom">
      <div class="title">
        <slot name="title"></slot>
      </div>
      <div class="op">
        <slot name="action"></slot>
      </div>
    </div> -->
  </div>
</template>

<script>
  export default {
    name: "sub-banner",
    data() {
      return {}
    },
    methods: {},
  }
</script>

<style scoped lang="scss">
  .v-banner {

    width: 100%;
    position: relative;
    text-align: left;

    .banner-wrapper{
      img {
        width: 100%;
        height: 15vw;
      }
    }


    .bottom {
      height: 7vw;
      display: flex;
      align-items: center;
    //   background: url('../assets/images/home/p2-projects-h-bg.png');
      background-size: 100% 100%;
      padding-left: 20%;

      .title {
        width: 38vw;
        height: 4.5vw;
        line-height: 4.5vw;
        font-size: 2.5vw;
        color: #ffffff;
        text-align: left;
      }

      .op {
        width: 19.5vw;
        margin-left: 4%;
        text-align: center;
        &>* {
          text-decoration: underline;
          font-size: 1.25vw;
          color: #1bb89d;
          cursor: pointer;
        }
      }
    }

  }
</style>



<style scoped>

/* 超小屏幕（手机，小于 768px） */
/* 没有任何媒体查询相关的代码，因为这在 Bootstrap 中是默认的（还记得 Bootstrap 是移动设备优先的吗？） */

/* 小屏幕（平板，大于等于 768px） */
@media (min-width: @screen-sm-min) { 
   
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media (min-width: @screen-md-min) { 

 }

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media (min-width: @screen-lg-min) { 

}
@media (max-width: 750px){
  
 
}
@media (min-width: 750px) and (max-width: 860px){

}
@media (min-width: 700px) and (max-width:1200px){
  
 .banner-wrapper img{
       height: 18vw !important;
    }
}
@media (max-width: 700px){                  
    .banner-wrapper img{
       height: 28vw !important;
    }
    
}
</style>



// WEBPACK FOOTER //
// src/components/sub-banner.vue